import { useMutation } from '@tanstack/react-query'
import { editChannel } from 'services/ChannelService'

export const useEditChannel = () => {
  return useMutation({ mutationFn: editChannel })
}
